export default "__VITE_ASSET__Bye$HUfW__"